import React, { Component } from "react";
import PropTypes from "prop-types";
import BaseButton from "../../Internals/BaseButton/BaseButton";
import ColorsPicker from "../../Internals/ColorsPicker";

import { colorArray } from "../../../styles/shared/tagsColors";

const INIT_COLOR = "#3e3e3e";

class AddTagButton extends Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  state = {
    clicked: false,
    selectedColor: INIT_COLOR
  };

  handleInputClick = () => {
    if (this.state.selectedColor === INIT_COLOR) {
      const selectedColor =
        colorArray[
          Math.floor(Math.random() * Math.floor(colorArray.length - 1))
        ];
      this.setState({ selectedColor });
    }
  };

  handleInputBlur = () => {
    if (
      this.inputRef.current.value !== null &&
      this.inputRef.current.value.length > 0
    ) {
      this.props.onAddNewTag({
        title: this.inputRef.current.value,
        color: this.state.selectedColor
      });
    }
    this.inputRef.current.value = null;
    this.setState({ selectedColor: INIT_COLOR });
    this.setState({ clicked: false });
  };

  handleSelectColor = color => {
    this.setState({ selectedColor: color });
    this.setState(prevState => ({ clicked: !prevState.clicked }));
    if (
      this.inputRef.current.value !== null &&
      this.inputRef.current.value.length > 0
    ) {
      this.props.onAddNewTag({ title: this.inputRef.current.value, color });
      this.inputRef.current.value = null;
      this.setState({ selectedColor: INIT_COLOR });
    }
  };

  handleOpenColorPicker = () => {
    this.setState(prevState => ({ clicked: !prevState.clicked }));
  };

  handleEnterKey = e => {
    e.stopPropagation();
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  render() {
    const circleStyle = { background: this.state.selectedColor };

    return (
      <div className="addTagButton__container">
        <BaseButton
          className="addTagButton__button addTagButton__button--small"
        >
          <div
            className="addTagButton__circle addTagButton__circle--small"
            style={circleStyle}
            onClick={this.handleOpenColorPicker}
          />
          <input
            ref={this.inputRef}
            className="addTagButton__input"
            onBlur={this.handleInputBlur}
            onClick={this.handleInputClick}
            onKeyDown={this.handleEnterKey}
            onKeyPress={this.handleEnterKey}
            placeholder="Add your own"
            type="text"
          />
        </BaseButton>
        {this.state.clicked ? (
          <ColorsPicker onClick={this.handleSelectColor} />
        ) : null}
      </div>
    );
  }
}

AddTagButton.propTypes = {
  /** func to call when new tag is added */
  onAddNewTag: PropTypes.func.isRequired
};

AddTagButton.defaultProps = {

};

export default AddTagButton;
